import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalEventEmitter, ModalStatusEnum } from '../../../modal/modal-status.enum';
import { RefundModalContent } from '../../refund-modal-content.interface';

@Component({
  template: ''
})
export class RefundSuccessModalComponent implements OnInit {
  @Output() event = new EventEmitter<ModalEventEmitter>();
  @Input() public content: RefundModalContent;
  @Input() public lang: string;

  public ticketsCount: number;
  public allItemsCount: number;

  constructor(protected bsModalRef: BsModalRef) {}

  ngOnInit() {}

  close(redirect: boolean = false) {
    this.event.emit({ state: redirect ? ModalStatusEnum.back : ModalStatusEnum.close });
    this.bsModalRef.hide();
  }
}
